export default __webpack_public_path__ + "6c6b49af3a86dfdd44e6757325eba24a.svg";